window.Handlebars.registerHelper({
  convertDate: function(date){
    'use strict';

    var dateObject = new Date(date);
    var formattedDateString = dateObject.getFullYear() + ' ' + dateObject.toLocaleString('en-US', {month: 'short'}) + ' ' + dateObject.getDate();

    return formattedDateString;
  },
  convertFileName: function(data) {
    'use strict';
    return data.split('.').pop().toUpperCase();
  },
  convertToMB: function(data){
    'use strict';
    return (data / 1000).toFixed(2) + ' MB';
  }
});
